import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_MISCELLANEOUS_RECORDS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_MISCELLANEOUS_RECORD:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_MISCELLANEOUS_RECORD:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_MISCELLANEOUS_RECORD:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_MISCELLANEOUS_RECORD:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
